export default "__VITE_ASSET__Bjy_dR7N__"